<template>
  <div class="videolist">
    <!--章-->
    <div class="list">
      <div class="title oneEllipsis" :class="{titactive: titactive}" @click.stop="getSectionList(item.id)">{{item.name}}</div>
    </div>
    <!--节-->
    <ul class="itemlist" v-show="titactive">
      <li class="boxSizing" v-for="(i,num) in SectionList" :key="num" @click="chapterFn(i,i.file_path)">
        <b class="money" :class="payState[i.charge].class" v-text="payState[i.charge].name"></b>
        <span class="oneEllipsis" :class="{titactive: titactive && $store.state.jieId === i.id}">{{(num+1) + '.' + i.name}}</span>
        <b class="iconfont icon-bofang1 playericon"></b>
      </li>
    </ul>
  </div>
</template>
<script>
import { Indicator } from 'mint-ui';
import axios from "axios";
import qs from "qs";
import { MessageBox } from "mint-ui";
import common from '../../common';
// function getVideoList(vue) {
//   let _this = vue;
//   axios
//     .post(
//       "/wap/CurriHandle/curriList",
//       qs.stringify({
//         bookId: 100135
//       })
//     )
//     .then(function (res) {
//       _this.videoList = res.data.data.curriculum_s;
//     })
//     ["catch"](function (error) {
//       console.log(error);
//     });
// }

//点击章时请求接口 渲染节的内容
function setSectionList(callback) {
  let _this = this;
  //Loading
  if (_this.IsExtendPlanel === false) {
      _this.IsExtendPlanel = !_this.IsExtendPlanel;
      Indicator.open({
          text: '加载中...',
          spinnerType: 'triple-bounce'
      });
  }else{
      _this.IsExtendPlanel = !_this.IsExtendPlanel;
  }
  return axios
    .post(
      "/wap/CurriHandle/getCurri",
      qs.stringify({
        id: this.item.id
      })
    )
    .then(function (res) {
       Indicator.close();
       //res 本章的所有信息
       _this.SectionList = res.data.data.videos;//所有节
        callback && typeof callback === "function" && callback(res);//微信支付成功后回调展示
    })
    ["catch"](function (error) {});
}
//点击章 渲染节的内容
function getSectionList(id,jieId) {
    //章id存到缓存，供微信支付时刷新页面无法监听子组件emit时使用
    localStorage.setItem('ChapterId',id);
  //id为章的id
  if (this.$store.state.listShow === id) {
    this.$store.commit("listShowChange", false);
    this.$emit("setChapterId", "");
  } else {
    this.$store.commit("listShowChange", id);
    this.$emit("setChapterId", id);
  }
  let _this = this;
  //setSectionList展开节后的回调——选中已支付的节
   _this.setSectionList((res)=>{
      var data = res.data.data.videos;
      data.map((item) =>{
        if(item.id == jieId){
            _this.$store.commit("videoPathsChange", true);//控制封面
            _this.$store.commit("jieChoosed", item);//控制当前节的选中样式
            _this.$store.commit("videoPathChange", item);//控制当前节的视频切换，初始化
        }
      });
  });
}
//点击节 免费直接观看 付费判断登录 去付费
var chapterFn = function (i, path) {
        if (path === undefined) {
            //判断是否登录，已登录跳到订单页
            axios
                .post(
                    "/wap/userHandle/getUserInfo",
                )
                .then(data => {
                    var data = data.data.data;
                    //未登录
                    if (data === 'notLogin') {
                        MessageBox.confirm('立即登录',{
                            title:"提示",
                            confirmButtonClass:'confirmButton',
                            cancelButtonClass:'cancelButton',
                            })
                            .then(() => {
                                this.$router.push({
                                    path: "/login",
                                    query: { redirect: location.hostname }
                                });
                            })
                            ["catch"](() => {
                                return false;
                            });
                    } else {
                        var myIP = returnCitySN.cip;
                        var jieobj = [
                            {
                                popname: "会员价购买",
                                price: this.parentCon.price,
                                jifen: this.parentCon.integral_price,
                                cover: this.parentCon.cover,
                                name: this.parentCon.videoListname,
                                bookId: {
                                    bookId: this.parentCon.bookId
                                },
                                axiospath: "/wap/IntegralHandle/getAllVideo", //默认积分支付购买整本书
                                axiospathwx: "/wap/WxpayFor/getAllVideo"//微信支付
                            },
                            {
                                popname: "购买一节",
                                price: i.price_money,
                                jifen: i.price_inte,
                                cover: i.cover,
                                name: i.name,
                                bookId: {
                                    videoId: i.id
                                },
                                axiospath: "/wap/IntegralHandle/getVideo", //积分支付购买一节
                                axiospathwx: "/wap/WxPayFor/getVideo" //微信支付
                            }
                        ];
                        this.$emit("tobuy", jieobj);
                    }
                })
                ["catch"](error => {
                    console.log(error);
                });
            }else{
                  this.$store.commit("videoPathChange", i);//控制视频播放
                  this.$store.commit("jieChoosed", i);//控制点击样式
                  this.$store.commit("videoPathsChange", true);//控制封面
              }
    //this.$store.commit("videoPathChange", i);
};
function currentChapter(_this) {
  var chapterId = common.getQueryString('curriId');
  //章id
  if (chapterId != _this.item.id) return false;
  _this.getSectionList = getSectionList;
  _this.getSectionList(chapterId).then(function () {
    if (!common.getQueryString('videoId')) return;
    for (let i = 0; i < _this.SectionList.length; i++) {
      if (_this.SectionList[i].id.toString() === common.getQueryString('videoId').toString()) {
        _this.$store.commit("videoPathChange", _this.SectionList[i]);
        _this.$store.commit("videoPathsChange", true);
      }
    }
  });
}
export default {
  name: "videolist",
  computed: {
    titactive: function () {
      //item.id 章id
      //点击章 $store.state.listShow 赋值 当前章id
      //判断点击的是当前章 给章加选中样式
      return this.$store.state.listShow.toString() === this.item.id.toString();
    }
    // jieActive: function() { return this.jieId === i.id) }
  },
  data() {
    return {
      IsExtendPlanel:false,
      videoList: "",
      SectionList: "",//节
      avtiveIndex: "",
      itemlist: false,
      chapterId: "",
      payState: [
        {
          name: "免费",
          class: ""
        },
        {
          name: "付费",
          class: "true"
        },
        {
          name: "已付",
          class: "payed"
        }
      ]
    };
  },
  created() {
    // getVideoList(this);
    this.chapterId = this.item.id;
    // if (this.titactive) {
    //     var id = this.$store.state.listShow;
    //     getSectionList(id);
    // }
  },
  mounted() {
      // console.log(common.getQueryString('curriId'));
    if (common.getQueryString('curriId')) currentChapter(this);
  },
  methods: {
    getSectionList,
    chapterFn,
    setSectionList
  },
  props: {
    item: {
      type: Object,
      default: {
        a: "12",
        b: "23"
      }
    },
    parentCon: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.titactive {
  color: #e9787c !important;
}
.videolist {
  clear: both;
  .list {
    .title {
      font-size: 28px;
      color: #333;
      height: 98px;
      line-height: 98px;
      border-bottom: 1PX solid #e6e7e8;
      padding: 0 30px;
      .active {
        border-bottom: 6px solid #ff8005;
        a {
          color: #333;
        }
      }
    }
  }
  .itemlist {
    li {
      font-size: 26px;
      color: #333;
      height: 98px;
      line-height: 98px;
      border-bottom: 1PX solid #e6e7e8;
      padding-left: 60px;
      position: relative;
      .playericon {
        color: #ff8005;
        font-weight: normal;
        font-size: 40px;
        float: right;
        padding-right: 30px;
      }
      .money {
        font-weight: normal;
        display: inline-block;
        width: 62px;
        height: 30px;
        line-height: 28px;
        padding-top: 6px;
        text-align: center;
        font-size: 20px;
        background: #91beac;
        color: #fff;
        position: absolute;
        top: 32px;
        left: 60px;
        border-radius: 2px;
        &.true {
          background: #e9787c;
        }
        &.payed {
          background: #d4a972;
        }
      }
      span {
        display: block;
        float: left;
        padding-left: 90px;
        width: 70%;
      }
    }
  }
}
</style>
